import { render, staticRenderFns } from "./ProfileViewAs.vue?vue&type=template&id=1530d6d8&"
import script from "./ProfileViewAs.vue?vue&type=script&lang=js&"
export * from "./ProfileViewAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports